
export const ALL_TDS_REQUEST = "ALL_TDS_REQUEST";
export const ALL_TDS_SUCCESS = "ALL_TDS_SUCCESS";
export const ALL_TDS_FAIL = "ALL_TDS_FAIL";